"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _attachListeners = _interopRequireDefault(require("./attachListeners"));
var usePlayer = function usePlayer(videoRef, isPlayerReady, setIsPlayerLoading, playbackURL) {
  (0, _react.useEffect)(function () {
    if (isPlayerReady) {
      var maxRetries = 5;
      var retryInterval = 10000;
      var numRetries = 0;
      var initialize = function initialize() {
        // eslint-disable-next-line no-undef
        var player = window.IVSPlayer.create();
        player.attachHTMLVideoElement(videoRef.current);
        player.load(playbackURL);
        player.play();
        if (numRetries >= maxRetries) {
          console.log('Max retries reached, giving up.');
          return;
        }
        (0, _attachListeners["default"])(player, function () {
          return setIsPlayerLoading(false);
        }, function (error) {
          setTimeout(function () {
            console.log('Trying to play again...');
            numRetries++;
            initialize();
          }, retryInterval);
        });
        return player;
      };
      var player = initialize();

      //Stop the player instance from emitting events when unmounting
      return function () {
        return player["delete"]();
      };
    }
  }, [videoRef, isPlayerReady, playbackURL]);
};
var _default = exports["default"] = usePlayer;